import React, { useEffect } from "react";
import confetti from "canvas-confetti";
import { useContext } from "react";
import { DContext } from "../../../../context/Datacontext";
import SuccesLogo from '../../../../assets/CC ATS Logo.svg'
import { useNavigate } from "react-router-dom";

const SuccessPage = () => {
    const {currentUser}=useContext(DContext)
    const navigate = useNavigate()
    useEffect(() => {
        // Continuous confetti background effect
        const duration = 10 * 100;
        const animationEnd = Date.now() + duration;

        (function frame() {
            confetti({
                particleCount: 2,
                angle: 60,
                spread: 55,
                origin: { x: 0 },
                colors: ["#2C25C4", "#8C18C3"],
            });
            confetti({
                particleCount: 2,
                angle: 120,
                spread: 55,
                origin: { x: 1 },
                colors: ["#2C25C4", "#8C18C3"],
            });
            if (Date.now() < animationEnd) {
                requestAnimationFrame(frame);
            }
        })();
    }, []);

    useEffect(()=>{
       setTimeout(() => {
           navigate('/')
       }, 500);
    })

    const handleButtonClick = () => {
        // Special burst effect on button click
        confetti({
            particleCount: 150,
            spread: 80,
            origin: { y: 0.6 },
        });
        navigate('/')        
    };

    return (
        <div className="flex flex-col justify-center items-center h-screen text-center bg-white">
            <img src={SuccesLogo} alt="" className="h-32" />
            <h1 className="text-3xl font-bold mb-4">You’re All Set!</h1>
            <p className="text-gray-600 mb-6">
                Everything’s set! We’ll now help you find the right job
            </p>
            <button
                onClick={handleButtonClick}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg shadow-lg transition"
            >
                Explore Opportunities
            </button>
        </div>
    );
};

export default SuccessPage;
